import axios from 'axios';
import FriendInviteActions from 'epic-fortnite-react/actions/FriendInviteActions';
import Cookies from 'universal-cookie';
import {v4 as uuidv4} from 'uuid';
import root from 'window-or-global';

import Url from '../constants/Url';

const getXsrfToken = () => {
  const cookies = new Cookies(root.document.cookie);
  const token = cookies.get('XSRF-TOKEN');
  if (token) {
    return token;
  }
  const newToken = uuidv4();
  cookies.set('XSRF-TOKEN', newToken);
  return newToken;
};

/**
 * FriendInviteSource
 *
 * Source mapping for sending a friend invite.
 *
 * For more information on source usage:
 * http://alt.js.org/docs/async/
 *
 */
const FriendInviteSource = {
  sendInvite: {
    remote(state, friendId, platform) {
      const xsrftoken = getXsrfToken();
      //the store state is accessible here
      return axios.post(Url().FRIEND_INVITE, {friendId, platform, xsrftoken});
    },
    //On success call the following action:
    success: FriendInviteActions.sendInviteSuccess,
    //On failure call the following action:
    error: FriendInviteActions.sendInviteFailure,
    shouldFetch() {
      return !root.__server_side_render;
    },
  },
};

export default FriendInviteSource;
